import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modalType: null,
  modalProps: {
    show: false,
  },
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, { payload }) => {
      //eslint-disable-next-line
      state.modalType = payload.modalType;
      state.modalProps = payload.modalProps;
    },
    closeModal: (state) => {
      //eslint-disable-next-line
      ((state.modalType = initialState.modalType),
        (state.modalProps = initialState.modalProps));
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
